import { render, staticRenderFns } from "./THGCO2Equivalent.vue?vue&type=template&id=a37e67e6&scoped=true"
import script from "./THGCO2Equivalent.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGCO2Equivalent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./THGCO2Equivalent.vue?vue&type=style&index=0&id=a37e67e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37e67e6",
  null
  
)

export default component.exports